import React from 'react';
import './online-offline-indicator.css';
import { Tooltip } from '@mui/material';
interface Props {
  isOnline: boolean;
}
const OnlineOfflineIndicator: React.FC<Props> = ({ isOnline }) => {
  const statusClass = isOnline ? 'online' : 'offline';
  return (
    <Tooltip title={isOnline ? 'Online' : 'Offline'}>
      <span className={statusClass} aria-hidden="true"></span>
    </Tooltip>
  );
};
export default OnlineOfflineIndicator;
